export const b64toFile = (dataURI, contentType, sliceSize, filename) => {
	contentType = contentType || '';
	sliceSize = sliceSize || 512;
	filename = filename || 'unknownfolder.jpg';

	let b64data = dataURI.split(',')[1] || dataURI;

	let byteCharacters = atob(b64data);
	let byteArrays = [];

	for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
		let slice = byteCharacters.slice(offset, offset + sliceSize);

		let byteNumbers = new Array(slice.length);
		for (let i = 0; i < slice.length; i++) {
			byteNumbers[i] = slice.charCodeAt(i);
		}

		let byteArray = new Uint8Array(byteNumbers);

		byteArrays.push(byteArray);
	}

	return new File(byteArrays, filename, {
		type: contentType,
		lastModified: Date.now(),
	});
};


export const checkMimeType = (event) => {
    //getting folder object
    let file = event.target.files[0]
    //define message container
    let err = ''
    // list allow mime type
    const types = ['image/png', 'image/jpeg', 'image/jpg', 'application/pdf']
    // loop access array

    // compare folder type find doesn't matach
    if (types.every(type => file.type !== type)) {
        // create error message and assign to container
        err += file.type+' is not a supported format\n';
    }

    if (err !== '') { // if message not same old that mean has error
        event.target.value = null // discard selected folder
        return false;
    }
    return true;
};

export const getFileType = (filename) =>{
    const extension = filename.slice(((filename.lastIndexOf(".") - 1) + 2)).toLowerCase();
	return extension === 'pdf' ? 'application/pdf' : (extension === 'png') ? 'image/png' : (extension === 'jpg') ? 'image/jpg' : (extension === 'jpeg') ? 'image/jpeg' : '';
}

export const b64toBlob = (b64Data, contentType) => {
	var byteCharacters = atob(b64Data);
	var byteArrays = [];
	for (let offset = 0; offset < byteCharacters.length; offset += 512) {
		var slice = byteCharacters.slice(offset, offset + 512),
			byteNumbers = new Array(slice.length);
		for (let i = 0; i < slice.length; i++) {
			byteNumbers[i] = slice.charCodeAt(i);
		}
		var byteArray = new Uint8Array(byteNumbers);
		byteArrays.push(byteArray);
	}
	return new Blob(byteArrays, { type: contentType });
};
